<template>
  <div class="col-xl-3 col-sm-6 col-md-4 product-card mb-4">
    <div class="product-label">
      <span class="ml-3" v-if="product.is_new">Новинки</span>
      <span class="ml-3" v-if="!product.is_new && product.has_discount">Cкидка</span>
<!--      <span class="ml-5" v-if="product.is_top">Топ</span>-->
      <img :src="`/images/${getDomainPrefix()}/catalog-label.svg`" alt=""
           v-if="product.is_new || product.has_discount ">
    </div>
    <div class="border rounded">
      <div class="row p-3">
        <div class="col-12 text-center my-5 product-image">
          <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url">
            <img :alt="product.brand_name + ' ' + product.name + ' ' + product.articul" :src="product.list_image"
                 class=" align-baseline mw-100 mh-100">
          </a>
        </div>
        <div class="col-12 product-name">
          <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url">
            {{ product.name }}
          </a>
        </div>
        <div class="col-6 ">
          <div class="base-price mt-2" v-if="product.has_discount">
            <money :price="product.base_price"/>
          </div>
        </div>
        <div class="col-6 text-right ">
          <div class="current-price ">
            <money :price="product.current_price"/>
          </div>
        </div>
        <div class="col-12">
          <hr/>
        </div>
        <div class="col-4 border-right">
          <div>
            <div>артикул</div>
            <div class="props-label">{{ product.articul }}</div>
          </div>
        </div>
        <div class="col-3  border-right">
          <div>
            <div>код</div>
            <div class="props-label">{{ product.code }}</div>
          </div>
        </div>
        <div class="col-5 ">
          <div>
            <div>в наличии</div>
            <div class="props-label">{{ product.smart_stock }}</div>
          </div>
        </div>
        <div class="col-12 justify-content-center d-flex mt-3">
          <div class="bg-secondary col-4 button-site text-center">
            <a target="_blank" v-on:click="ym(102261723,'reachGoal','topride')"
               :href="'https://www.pride.ru/catalog/item/'+product.id+'/'"><img src="/images/magaz.png"
                                                                                class="mw-100 p-2" alt=""></a>
          </div>
          <div class="bg-secondary col-4 button-ozon text-center">
            <a target="_blank" v-on:click="ym(102261723,'reachGoal','toozon')" v-if="!product.external_vendor_info[1]"
               :href="'https://www.ozon.ru/search/?text=' + encodeURIComponent(product.name + ' ' + product.brand_name) + '&from_global=true'"><img
                src="/images/ozon.png" class="mw-100 p-2" alt=""></a>
            <a target="_blank" v-on:click="ym(102261723,'reachGoal','toozon')" v-else
               :href="'https://www.ozon.ru/product/' + product.external_vendor_info[1] + '/'"><img
                src="/images/ozon.png" class="mw-100 p-2" alt=""></a>
          </div>
          <div class="bg-secondary col-4 button-wb text-center">
            <a target="_blank" v-on:click="ym(102261723,'reachGoal','towb')" v-if="!product.external_vendor_info[2]"
               :href="'https://www.wildberries.ru/catalog/0/search.aspx?search=' + encodeURIComponent(product.name+ ' ' + product.brand_name)"><img
                src="/images/wb.png" class="mw-100 p-2" alt=""></a>
            <a target="_blank" v-on:click="ym(102261723,'reachGoal','towb')" v-else
               :href="'https://www.wildberries.ru/catalog/' + product.external_vendor_info[2] + '/detail.aspx'"><img
                src="/images/wb.png" class="mw-100 p-2" alt=""></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Money from "@/components/core/Money";

export default {
  name: 'Product',
  components: {Money},
  props: ['product', 'category'],
  methods: {
    getDomainPrefix() {
      const hostname = window.location.hostname;
      if (hostname.includes('thorvik')) {
        return 'thorvik';
      } else if (hostname.includes('ombra')) {
        return 'ombra';
      }
      return 'thorvik'; // fallback
    }
  }
}
</script>

<style scoped>

</style>
